module.exports = __webpack_public_path__ + "img/Zahnrad.7c7bb88f.png";